/** What the Android hardware Back should do on a given press. */
export type NativeBackAction = 'history' | 'minimise';

/**
 * The native back button does NOT reach the web layer by itself: Capacitor
 * hands us its own `canGoBack`, computed from the WebView's navigation list.
 * Overlays (sheets, dialogs, the board's edit mode) arm a `pushState` entry
 * that this flag does not always reflect — so a Back with a dialog open on a
 * freshly restored route minimised the whole app instead of closing the dialog
 * (beta, build 32).
 *
 * The overlay stack therefore wins: if a layer is open, go back in history and
 * let OverlayBackStackService's popstate handler close exactly one layer.
 */
export function resolveNativeBackAction(overlayIsOpen: boolean, canGoBack: boolean): NativeBackAction {
    return overlayIsOpen || canGoBack ? 'history' : 'minimise';
}
